document.addEventListener('DOMContentLoaded', function() {
  const gallerySliders = document.querySelectorAll('.gallery-slider');

  gallerySliders.forEach(initGallerySlider);
});

function initGallerySlider(container) {
  const slides = container.querySelectorAll('.gallery-slide');
  const progressBars = container.querySelectorAll('.progress-bar');
  const prevButton = container.querySelector('.gallery-slider-prev');
  const nextButton = container.querySelector('.gallery-slider-next');
  const track = container.querySelector('.gallery-slider-track');

  if (slides.length === 0) return;

  let currentSlide = 0;

  // Initialize first slide
  updateSlide(0);

  // Function to update slide display
  function updateSlide(index) {
    // Clamp index to valid range
    currentSlide = Math.max(0, Math.min(index, slides.length - 1));

    // Update slides active state
    slides.forEach((slide, i) => {
      if (i === currentSlide) {
        slide.classList.add('active');
      } else {
        slide.classList.remove('active');
      }
    });

    // Update progress bars - just show active state
    progressBars.forEach((bar, i) => {
      bar.classList.remove('active', 'completed');
      if (i === currentSlide) {
        bar.classList.add('active');
      }
    });

    // Update navigation buttons - allow looping so never truly disabled
    if (prevButton) {
      prevButton.disabled = false;
    }
    if (nextButton) {
      nextButton.disabled = false;
    }
  }

  // Navigation functions
  function goToNext() {
    if (currentSlide < slides.length - 1) {
      updateSlide(currentSlide + 1);
    } else {
      updateSlide(0);
    }
  }

  function goToPrev() {
    if (currentSlide > 0) {
      updateSlide(currentSlide - 1);
    } else {
      updateSlide(slides.length - 1);
    }
  }

  function goToSlide(index) {
    if (index === currentSlide) return;
    updateSlide(index);
  }

  // Event listeners for navigation buttons
  if (nextButton) {
    nextButton.addEventListener('click', goToNext);
  }

  if (prevButton) {
    prevButton.addEventListener('click', goToPrev);
  }

  // Event listeners for clicking on slides to make them active
  slides.forEach((slide, index) => {
    slide.addEventListener('click', () => {
      goToSlide(index);
    });
  });

  // Event listeners for progress bars (click to jump to slide)
  progressBars.forEach((bar, index) => {
    bar.addEventListener('click', () => {
      goToSlide(index);
    });
  });

  // Touch swipe support (mobile)
  let touchStartX = 0;
  let touchEndX = 0;

  container.addEventListener('touchstart', (e) => {
    touchStartX = e.changedTouches[0].screenX;
  }, { passive: true });

  container.addEventListener('touchend', (e) => {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipe();
  }, { passive: true });

  function handleSwipe() {
    const swipeThreshold = 50;
    const diff = touchStartX - touchEndX;

    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        // Swipe left - next slide
        goToNext();
      } else {
        // Swipe right - previous slide
        goToPrev();
      }
    }
  }

  // Keyboard navigation
  container.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      goToPrev();
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      goToNext();
    }
  });

  // Make container focusable for keyboard navigation
  container.setAttribute('tabindex', '0');
}
